
export class PurchaseV3 {

  constructor(params) {
    this.mps = params.mps;
    this.allCrossSellInput = document.getElementById(params.formCrossSellInputId || "csid");

    this.initEvents();
    this.consolidateCrossells();

  }

  sendToMixpanel(event, properties) {
    if (this.mps)  {
      this.mps.send(event, properties);
    }
  }

  consolidateCrossells() {
    this.allCrossSellInput.value = Array.from(document.querySelectorAll('input[type="checkbox"][data-cross-sell="input"]:checked')).map(input => input.value).join(',');
  }

  initEvents() {
    document.querySelectorAll('input[type="checkbox"][data-cross-sell="input"]').forEach((checkbox) => {
      checkbox.addEventListener('change', () => this.consolidateCrossells());
    });
  }

}